<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <div class="panel-title">
      <h2>
        {{ infoTitle }}
      </h2>
    </div>

    <div class="panel-text">
      <div [innerHTML]="infoText"></div>
    </div>

    <div class="panel-buttons">
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('close')"
        (click)="onClose()"
      ></app-button>
    </div>
  </div>
</div>
